// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4f672dc4","732":"696b1136","977":"62babad5"}[chunkId] + ".chunk.js";
};